/**
 * @desc 通过spu获取军团信息
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.SpuAndCorpsInfoResponseDto>>;
export function request(body: Array<string>, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/corpsInfo/bySpuList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
